import { pr } from '@/utils/pxToRem';
import { Box, Stack } from '@mui/material';
import React from 'react';
// Component
import FareInMonth from './FareInMonth';

function Section04(props: any) {
  const {
    days, onSearchFlight, routeName, isDesktop,
  } = props;

  return (
    <Stack
      spacing={pr`16px`}
      sx={{ mt: pr`8px` }}
    >
      <Box
        sx={{
          background: '#FFFFFF',
          boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
          borderRadius: '12px',
        }}
      >
        <FareInMonth
          isDesktop={isDesktop}
          days={days}
          onSearchFlight={onSearchFlight}
          numberDayInMonth={3}
          routeName={routeName}
        />
      </Box>

    </Stack>
  );
}

export default React.memo(Section04);
